/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface DeviceDto
 */
export interface DeviceDto {

    /**
     * Unique identifier
     *
     * @type {number}
     * @memberof DeviceDto
     * @example 1
     */
    id: number;

    /**
     * Creation timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof DeviceDto
     * @example 2024-01-15T10:30:00.000Z
     */
    created: string;

    /**
     * Last update timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof DeviceDto
     * @example 2024-06-01T08:00:00.000Z
     */
    updated: string;

    /**
     * Soft-delete timestamp — null when the record is active
     *
     * @type {string}
     * @memberof DeviceDto
     */
    deleted: string | null;

    /**
     * Human-readable name for the device (e.g. \"iPhone\" or \"Pixel 8 Pro\")
     *
     * @type {string}
     * @memberof DeviceDto
     */
    name: string;

    /**
     * Hardware identifier (e.g. \"iPhone13,3\")
     *
     * @type {string}
     * @memberof DeviceDto
     */
    deviceId: string;

    /**
     * OS version (e.g. \"ios\", \"android\")
     *
     * @type {string}
     * @memberof DeviceDto
     */
    platform: DeviceDtoPlatformEnum;

    /**
     * @type {string}
     * @memberof DeviceDto
     */
    systemVersion: string;

    /**
     * @type {string}
     * @memberof DeviceDto
     */
    appVersion: string;

    /**
     * @type {string}
     * @memberof DeviceDto
     */
    manufacturer: string;

    /**
     * @type {string}
     * @memberof DeviceDto
     */
    uniqueId: string;

    /**
     * @type {string}
     * @memberof DeviceDto
     */
    publicKey: string;

    /**
     * @type {JoinEntityDto}
     * @memberof DeviceDto
     */
    user: JoinEntityDto;
}

/**
 * @export
 * @enum {string}
 */
export enum DeviceDtoPlatformEnum {
    IOS = 'IOS',
    ANDROID = 'ANDROID'
}

